export default function FaqPage() {
  const faqs = [
    { q: '如何注册易欧账户？', a: '打开易欧官网或APP，点击注册按钮，输入手机号或邮箱，设置登录密码并完成短信或邮箱验证即可。' },
    { q: '充值多久到账？', a: '法币充值通常即时到账；加密货币充值需要链上确认，一般在几分钟到几十分钟内完成，具体取决于网络拥堵程度。' },
    { q: '提现手续费是多少？', a: '提现手续费根据币种和当前链上情况动态调整，在提现页面会明确显示当前费用。' },
    { q: '现货和合约的交易费率一样吗？', a: '现货和合约的费率结构不同。现货可享受阶梯费率，合约交易还需关注资金费率。具体费率可在费用页面查看。' },
    { q: '如何重置交易密码？', a: '在账户安全设置中选择重置资金密码，按提示完成身份验证后即可设置新密码。' },
    { q: '平台支持哪些币种交易？', a: '易欧支持数百种数字资产的现货和合约交易，覆盖主流币种和热门项目，具体列表可在交易页面查看。' },
  ]

  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">易欧常见问题</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            关于注册、充值、交易和账户安全的常见问题解答。
          </p>
        </div>

        <div className="space-y-4" data-unique-module="frequently-asked-questions">
          {faqs.map((item, i) => (
            <details key={i} className="cyber-card group cursor-pointer">
              <summary className="text-cyber-text font-medium p-6 cursor-pointer hover:text-accent transition-colors list-none flex items-center justify-between">
                <span className="flex items-center gap-3">
                  <span className="text-accent-2 font-mono text-sm">[0{i + 1}]</span>
                  {item.q}
                </span>
                <svg className="w-5 h-5 shrink-0 group-open:rotate-180 transition-transform text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="px-6 pb-6 border-t border-cyber-border/50 pt-4">
                <p className="text-muted leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </div>
  )
}
